import { Controller } from "@hotwired/stimulus"

// The wiki's editor: a textarea that can wrap a selection in markdown, and
// show what it will look like. The preview is rendered by the server (the
// same Commonmarker + sanitize the public page uses, see Jane::PagesController
// #preview), so there is no markdown library on this side and no way for the
// two renders to disagree. The rich editor is the other one: qir's `editor`.
//
// Ships with fire, registered by the host as "markdown" — see HOTWIRE.md.
export default class extends Controller {
  static targets = ["input", "preview", "tab"]
  static values = { url: String }

  // Toolbar. before/after params say what to put around the selection; with
  // nothing selected the marks go in and the caret lands between them.
  wrap({ params: { before = "", after = "" } }) {
    const el = this.inputTarget
    const { selectionStart: from, selectionEnd: to } = el
    el.setRangeText(before + el.value.slice(from, to) + after, from, to, "select")
    if (from === to) el.setSelectionRange(from + before.length, from + before.length)
    el.focus()
  }

  write() {
    this.#show("write")
  }

  async preview() {
    this.#show("preview")
    const body = new FormData()
    body.append("body", this.inputTarget.value)
    const res = await fetch(this.urlValue, {
      method: "POST",
      body,
      headers: { "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content }
    })
    this.previewTarget.innerHTML = await res.text()
  }

  #show(tab) {
    this.inputTarget.classList.toggle("hidden", tab === "preview")
    this.previewTarget.classList.toggle("hidden", tab === "write")
    this.tabTargets.forEach((el) => {
      el.classList.toggle("tab-active", el.dataset.tab === tab)
      el.setAttribute("aria-selected", el.dataset.tab === tab)
    })
  }
}
